import { useCallback } from 'react';
import axios from 'axios';

import { useSysconfig } from '~/components/SystemConfiguration/SystemConfigurationScreen';
import useDataFetcher from '~/components/useDataFetcher';

import type { AiClaimImportRunListResponse, AiClaimImportRunProgress } from '../types';

export const useAiClaimImport = () => {
  // @ts-expect-error TODO: useSysconfig hook needs TypeScript definition
  const { organization } = useSysconfig();
  const urlPrefix = `/sysconfig/api/v1/organizations/${organization.id}/ai_claim_import`;

  const {
    data: runList,
    isLoading: isRunListLoading,
    reloadData: reloadRunList,
  } = useDataFetcher<AiClaimImportRunListResponse>(`${urlPrefix}/runs`);

  const fetchRunProgress = useCallback(
    async (runId: string): Promise<AiClaimImportRunProgress> => {
      const { data } = await axios.get<AiClaimImportRunProgress>(`${urlPrefix}/runs/${runId}/progress`);
      return data;
    },
    [urlPrefix]
  );

  return {
    runList,
    isRunListLoading,
    reloadRunList,
    fetchRunProgress,
  };
};
